import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiBookOpen, FiCheckCircle } from 'react-icons/fi';
import api, { RUTA_ARCHIVOS } from '../api/client';

export default function MisCursos() {
    const [cursos, setCursos] = useState([]);
    const [tab, setTab] = useState('progreso');
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        api.get('/cursos/mis-cursos').then(r => setCursos(r.data.cursos || [])).finally(() => setCargando(false));
    }, []);

    if (cargando) return <div className="loader"><div className="spinner" /><span>Cargando...</span></div>;

    const enProgreso = cursos.filter(c => !c.completado);
    const completados = cursos.filter(c => c.completado);
    const lista = tab === 'progreso' ? enProgreso : completados;

    return (
        <div>
            <h1 style={{ margin: '0 0 16px', fontSize: 24 }}>Mis Cursos</h1>

            <div className="tabs">
                <button className={tab === 'progreso' ? 'activa' : ''} onClick={() => setTab('progreso')}>
                    En progreso ({enProgreso.length})
                </button>
                <button className={tab === 'completados' ? 'activa' : ''} onClick={() => setTab('completados')}>
                    Completados ({completados.length})
                </button>
            </div>

            {lista.length === 0 ? (
                <div className="card" style={{ textAlign: 'center', padding: 40, color: 'var(--texto-suave)' }}>
                    {tab === 'progreso' ? 'No tienes cursos en progreso. ' : 'Aun no has completado ningun curso. '}
                    <Link to="/cursos">Ver cursos disponibles</Link>
                </div>
            ) : (
                <div className="cursos-grid">
                    {lista.map(curso => (
                        <Link key={curso.id} to={`/curso/${curso.id}`} className="curso-card" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="curso-cover">
                                {curso.imagen_portada ? (
                                    <img src={curso.imagen_portada.startsWith('http') ? curso.imagen_portada : `${RUTA_ARCHIVOS}${curso.imagen_portada}`} alt={curso.nombre} />
                                ) : (
                                    <FiBookOpen />
                                )}
                                {curso.completado && <span className="badge"><FiCheckCircle /> Completado</span>}
                            </div>
                            <div className="curso-body">
                                <h3 className="curso-titulo">{curso.nombre}</h3>
                                <p className="curso-prof">{curso.profesor_nombre || 'Sin profesor'}</p>
                                <div className="curso-meta">
                                    <span>{Math.round(curso.progreso_porcentaje || 0)}% completado</span>
                                </div>
                                <div className="barra-progreso" style={{ marginTop: 10 }}>
                                    <div className="barra-progreso-fill" style={{ width: `${curso.progreso_porcentaje}%` }} />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
